import validate from "/app/node_modules/nuxt/dist/pages/runtime/validate.js";
import debug_45window_45global from "/app/app/middleware/debug-window.global.ts";
import manifest_45route_45rule from "/app/node_modules/nuxt/dist/app/middleware/route-rules.js";
export const globalMiddleware = [
  validate,
  debug_45window_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}